import {Box, IconButton} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import {FullscreenImageActions} from "../../widgets/FullscreenImageActions";
import {GenerationType} from "../types/GenerationType.ts";
import {useImageSize} from "../hooks/useImageSize.ts";
import {getCalculatedImageSize, } from "../../utils/imageSizeCalculations.ts";
import {MediaSkeleton} from "./MediaSkeleton.tsx";
import {useState} from "react";


interface IFullscreenGeneratedContentProps {
    src: string;
    type: GenerationType
    onClose: () => void;
    onDownLoad: () => void

}

export const FullscreenGeneratedContent = ({src, onClose, type, onDownLoad}: IFullscreenGeneratedContentProps) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const {dimensions} = useImageSize(src);

    const MAX_WIDTH = window.innerWidth * 0.9;
    const MAX_HEIGHT = window.innerHeight * 0.7;

    const calculatedSize = dimensions
        ? getCalculatedImageSize(dimensions.width, dimensions.height, MAX_WIDTH, MAX_HEIGHT)
        : {width: MAX_WIDTH, height: window.innerHeight * 0.7};

    const containerWidth = calculatedSize.width;
    const containerHeight = calculatedSize.height;

    const handleDownload = () => {
        onDownLoad()
        onClose()
    }


    const renderMedia = () => {
        switch (type) {
            case 'video':
                return (

                    <Box
                        component="video"
                        src={src}
                        loop
                        muted
                        playsInline
                        autoPlay
                        onLoadedData={() => setIsLoaded(true)}
                        sx={{
                            height: containerHeight,
                            width: containerWidth,
                            borderRadius: '8px',
                            objectFit: 'contain',
                            display: isLoaded ? 'block' : 'none'
                        }}
                    />

                );
            case 'image':
            default:
                return (

                    <Box
                        component="img"
                        src={src}
                        alt="generated content"
                        onLoad={() => setIsLoaded(true)}
                        sx={{
                            height: containerHeight,
                            width: containerWidth,
                            borderRadius: '8px',
                            objectFit: 'contain',
                            display: isLoaded ? 'block' : 'none'
                        }}
                    />

                );
        }
    };

    return (
        <Box sx={{position: 'relative', display: 'inline-block', width: containerWidth, height: containerHeight}}>
            {!isLoaded && (
                <MediaSkeleton
                    width={containerWidth}
                    height={containerHeight}
                    borderRadius="8px"
                />
            )}
            {renderMedia()}
            <IconButton
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    color: 'white',

                }}
            >
                <CloseIcon/>
            </IconButton>
            <FullscreenImageActions onDownload={handleDownload}/>
        </Box>
    );
};
